/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { DateTimeString, date } from 'common'
export type __FORCE_MODULE__ = unknown; //We add this line so that even if the file ends up being empty, it will still be recognized as a module without impacting the bundle size.

export class FourYearPlannerCourseVM {
  courseGu?: string;
  courseId?: string;
  courseTitle?: string;
  gradeCode?: string;
  creditType?: string;
  subjectAreaCode?: string;
  extensionCode?: string;
  completedCredits: number = 0;
  attemptedCredits: number = 0;
  locked: boolean = false;
  courseHistory: Array<CreditInfo> = [];
  primarySubjectAreaDesc?: string;
  overflowCreditInfos: Array<OverflowCreditInfo> = [];
  altCourses: Array<AlternateCourseInfo> = [];
  prerequisitesMet: boolean = false;
  description?: string;
  courseOrgInfo: StuEnrolledOrgInfo = new StuEnrolledOrgInfo;
  creditTypeIsCHS: boolean = false;
  showHoverInfo: boolean = false;
  showHoverInfoSA: boolean = false;
  selectedHomeSchoolCurriculum?: string;
}

export class FourYearPlannerVM {
  currentGradeLevel?: string;
  currentGradeCode?: string;
  courses: Array<FourYearPlannerCourseVM> = [];
  subjectAreas: Array<FourYearPlannerSubjectAreaVM> = [];
  gradeCodes: Array<LookupValueInfo> = [];
  subjectAreaGradeInfos: Array<SubjectAreaGradeInfo> = [];
  gradReqDefinitions: Array<LookupValueInfo> = [];
  diplomaTypes: Array<LookupValueInfo> = [];
  careerPlanOptions: Array<LookupValueInfo> = [];
  enrolledOrgsLookup: Array<LookupValueInfo> = [];
  stuPrimaryOrg: StuEnrolledOrgInfo = new StuEnrolledOrgInfo;
  gradReqDefGU?: string;
  diplomaType?: string;
  careerPlanGU?: string;
  gradesToBePlanned: Array<string> = [];
  isDraft: boolean = false;
  hasPlan: boolean = false;
  isEditing: boolean = false;
  stuCplGU?: string;
  isEditable: boolean = false;
  useDiplomaType: boolean = false;
  resetWarningMsg?: string;
  showPace: boolean = false;
  canChangeCoursePlanSelection: boolean = false;
  hideCoursePlanSelection: boolean = false;
  showOrgInfo: boolean = false;
  showOrgLookup: boolean = false;
  showHomeSchoolCurriculum: boolean = false;
  homeSchoolCurriculumOptions: Array<LookupValueInfo> = [];
}

export class LaunchPadDefinition {
  userType: UserType = UserType.Staff;
  enableParentVUE: boolean = false;
  enableStudentVUE: boolean = false;
  identity?: string;
  title?: string;
  description?: string;
  gridLayout?: string;
  tileTheme?: string;
  links: Array<Link> = [];
}

export class ModuleConfigInfo {
  pxpModuleCfgGU?: string;
  organizationYearGU?: string;
  name?: string;
  module?: string;
  isEnabled?: string;
  iconUrl?: string;
  moduleUrl?: string;
  moduleOrder: number = 0;
}

export enum UserType {
  Staff = 0,
  Parent = 1,
  Student = 2,
  Other = 3,
}

export class PXPModuleDef {
  name?: string;
  moduleCode?: string;
  iconUrl?: string;
  moduleUrl?: string;
  activeForParents: boolean = false;
  activeForStudents: boolean = false;
  isUdModule: boolean = false;
}

export class GetLunchOrderInfoResponse {
  lunchOrdersListForSchool: LunchOrdersListForSchool = new LunchOrdersListForSchool;
  lunchOrdersForStudent: LunchOrdersForStudent = new LunchOrdersForStudent;
  validSchoolDays: Array<string> = [];
  cutOffTime?: string;
}

export class UpdateLunchOrderInfoResponse {
  mealGU?: string;
  result: boolean = false;
}

export class StudentLunchOrder {
  mealDate?: string;
  mealGU?: string;
  mealOptionID?: string;
  mealText?: string;
  sectionGU?: string;
  universalBreakfast?: string;
  delete: boolean = false;
}

export class StudentInfo {
  AGU?: string;
  sisNumber?: string;
  name?: string;
  schoolName?: string;
  schoolPhone?: string;
  photoUrl?: string;
}

export class SvueStuHallPassDataVM {
  currentHallPass: ComponentHallPassData = new ComponentHallPassData;
  futureHallPasses: Array<ComponentHallPassData> = [];
  locations: Array<ComponentRoomData> = [];
  noRoomsSetup: boolean = false;
  studentInQMsg?: string;
  ssyGU?: string;
}

export class ComponentRoomData {
  roomGU?: string;
  roomName?: string;
  color?: string;
  iconPath?: string;
  maxTime: number = 0;
  approvalRequired: boolean = false;
}

export class ComponentHallPassData {
  hallPassGU?: string;
  studentGU?: string;
  dateTime?: string;
  room: ComponentRoomData = new ComponentRoomData;
  startDateTime: DateTimeData = new DateTimeData;
  endDateTime: DateTimeData = new DateTimeData;
  status?: string;
  countUp: boolean = false;
  expired: boolean = false;
}

export class CreateHallPassResponse {
  currentHallPassData: ComponentHallPassData = new ComponentHallPassData;
  success: boolean = false;
}

export class HallPassResponseBase {
  success: boolean = false;
}

export class CheckActivateQueuedHallPassResponse {
  status?: string;
  currentHallPassData: ComponentHallPassData = new ComponentHallPassData;
  success: boolean = false;
}

export class CreditInfo {
  month: number = 0;
  year: number = 0;
  term?: string;
  credit: number = 0;
  mark?: string;
  hasValue: boolean = false;
}

export class OverflowCreditInfo {
  creditsApplied: number = 0;
  subjectAreaCode?: string;
  subjectAreaName?: string;
  creditsCompleted: number = 0;
  creditsAttempted: number = 0;
}

export class AlternateCourseInfo {
  courseGU?: string;
  courseID?: string;
  courseTitle?: string;
  credits?: string;
}

export class StuEnrolledOrgInfo {
  organizationGU?: string;
  organizationYearGU?: string;
  organizationName?: string;
  primaryOrg: boolean = false;
}

export class FourYearPlannerSubjectAreaVM {
  subjectAreaCode?: string;
  subjectAreaName?: string;
  creditsCompleted: number = 0;
  creditsInProgress: number = 0;
  creditsRequested: number = 0;
  creditsRemaining: number = 0;
  requiredCredits: number = 0;
}

export class LookupValueInfo {
  order: number = 0;
  value?: string;
  description?: string;
}

export class SubjectAreaGradeInfo {
  subjectAreaCode?: string;
  gradeCode?: string;
  minCredits: number = 0;
  maxCredits: number = 0;
  paceCredits: number = 0;
}

export class LoadDataResponse {
  frontlineAuthUrl?: string;
  accessToken?: string;
  userInfo?: string;
}

export class Link {
  identity?: string;
  title?: string;
  description?: string;
  module?: string;
  type?: string;
  iconType?: string;
  image?: string;
  icon?: string;
  iconColor?: string;
  url?: string;
  launchUrl?: string;
}

export class LunchOrdersListForSchool {
  lunchOrderList: Array<LunchOrder> = [];
}

export class LunchOrdersForStudent {
  studentSchoolYearGU?: string;
  studentLunchOrders: Array<StudentLunchOrder> = [];
}

export class DateTimeData {
  year: number = 0;
  month: number = 0;
  day: number = 0;
  hour: number = 0;
  minute: number = 0;
  second: number = 0;
}

export class LunchOrder {
  mealOptionID: number = 0;
  orderDescription?: string;
}
